module.exports = __webpack_public_path__ + "img/orange_money.ebb2e30e.png";